import {
  Center,
  MantineBreakpoint,
  UnstyledButton,
  useMantineTheme,
} from '@mantine/core';
import DHLogo from 'src/assets/img/logo-dh.svg?react';

type LogoPropsType = {
  toggleMenu: () => void;
  hiddenFrom?: MantineBreakpoint;
  visibleFrom?: MantineBreakpoint;
};

export const Logo: React.FC<LogoPropsType> = ({
  toggleMenu,
  hiddenFrom,
  visibleFrom,
}) => {
  const theme = useMantineTheme();

  return (
    <UnstyledButton
      onClick={toggleMenu}
      hiddenFrom={hiddenFrom}
      visibleFrom={visibleFrom}
    >
      <Center>
        <DHLogo
          width={36}
          height={24}
          color={__ENV_NAME__ === 'prod' ? theme.colors['layout'][8] : 'red'}
          style={{ marginLeft: '5px' }}
        />
      </Center>
    </UnstyledButton>
  );
};
